// src/firebaseMessaging.js
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { db, auth } from './firebase';
import { doc, updateDoc, arrayUnion } from 'firebase/firestore';

export const setupNotifications = async () => {
  const messaging = getMessaging();
  const vapidKey = "BBDscrrLgLofEUsCXAQukUAvws9_fla8JAoy6z0n73LFfAM6MYUKxO-eagVtOQhq28clLVJrwugtoFUbK62J8Og"; // Get this from Firebase Console

  // 1. Request Permission
  console.log('Requesting permission...');
  const permission = await Notification.requestPermission();

  if (permission === 'granted') {
    console.log('Notification permission granted.');

    // 2. Get Device Token
    try {
      const currentToken = await getToken(messaging, { vapidKey: vapidKey });
      if (currentToken) {
        console.log('FCM Token:', currentToken);
        // 3. Save Token to Firestore
        sendTokenToServer(currentToken);
      } else {
        console.log('No registration token available. Request permission to generate one.');
      }
    } catch (err) {
      console.log('An error occurred while retrieving token. ', err);
    }
  } else {
    console.log('Unable to get permission to notify.');
  }

  // Handle foreground messages (when the app is open)
  onMessage(messaging, (payload) => {
    console.log('Message received in foreground. ', payload);
    // You can show an in-app notification or UI update here
    new Notification(payload.notification.title, {
        body: payload.notification.body,
        icon: '/logo192.png'
    });
  });
};

const sendTokenToServer = async (token) => {
  const user = auth.currentUser;
  if (user) {
    const userDocRef = doc(db, 'users', user.uid);
    // Use arrayUnion to add the token only if it's not already there.
    // This prevents duplicate tokens for the same device.
    await updateDoc(userDocRef, {
      fcmTokens: arrayUnion(token)
    });
    console.log('Token saved to Firestore.');
  }
};
